import React from 'react';
import { useTranslation } from 'react-i18next';

interface OperationManagementPowerPlantRegistrationModalTopNavigationProps {
  testId?: string;
  className?: string;
  selectedIndex?: number;
  menus?: Array<{ text: string; context?: string }>;
  setNavigationIndex?: React.Dispatch<React.SetStateAction<number>>;
}

const defaultMenus = [
  { text: 'management.navigation.batchRegistration', context: null },
  { text: 'management.navigation.singleRegistration', context: null },
];

export const OperationManagementPowerPlantRegistrationModalTopNavigation: React.FC<
  OperationManagementPowerPlantRegistrationModalTopNavigationProps
> = ({ testId, className, selectedIndex, menus, setNavigationIndex }) => {
  const { t } = useTranslation();
  const selectedClass =
    'noto-14-bold text-dark-3 border-b-2 border-teal-main pt-[13px] pb-[11px]';
  const defaultClass = 'noto-14-normal  text-dark-10 py-[13px]';

  return (
    <nav data-testid={testId} className={`${className}`}>
      <div className="flex">
        {(menus ?? defaultMenus).map((menu, index) => {
          return (
            <div
              data-testid={`${testId}-${menu.text.split('.')[2].toLowerCase()}`}
              key={index}
              onClick={() => setNavigationIndex?.(index)}
              className={`${index === selectedIndex ? selectedClass : defaultClass} ${index === 0 ? '' : 'ml-[22px]'} flex w-fit cursor-pointer items-center justify-center px-[4px] leading-[23px]`}
            >
              {t(menu.text, {
                context: menu.context,
              })}
            </div>
          );
        })}
      </div>
    </nav>
  );
};
